import React from 'react'
import { connect } from 'react-redux'
import { editSets } from "../../actions/settings"
import DeleteConfirmation from '../ui/DeleteConfirmation'
import SettingsItemForm from './SettingsItemForm'

class SetsSakhItem extends SettingsItemForm {

  modelName = 'sakh'

  render() {
    const { data } = this.props;
    const { data: nData, errors } = this.state;

    const delConf = this.state.delConf ?
      <DeleteConfirmation
        onDelete={this.deleteItem}
        onCancel={this.toggleDelConf}
      />
      :
      '';

    if(this.state.editing){
      return(
        <tr>
          <td>
          {delConf}
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.sakh_team}
                name="sakh_team"
                onChange={this.updateInput}
                placeholder="Команда"
                autoFocus
              />
            </div>
            <div className="form-inline">
              <button  type="button" className="btn btn-success"
                onClick={this.saveItem} title="Сохранить">
                <span className="glyphicon glyphicon-save"></span>
              </button>{" "}
              <button type="button" className="btn btn-default"
                onClick={this.cancelEditing} title="Отменить">
                <span className="glyphicon glyphicon-remove"></span>
              </button>{" "}
              <button type="button" className="btn btn-danger"
                onClick={this.toggleDelConf} title="Удалить">
                <span className="glyphicon glyphicon-trash"></span>
              </button>
            </div>
            <div className="form-inline">
              Соц.{" "}
              <input
                type="checkbox"
                className="form-control"
                checked={nData.sakh_special}
                name="sakh_special"
                onChange={this.handleChBox}
                title="Соц. защита"
              />
            </div>
            {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          </td>
          <td>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.sakh_email}
                name="sakh_email"
                onChange={this.updateInput}
                placeholder="Email"
              />
            </div>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.sakh_tel}
                name="sakh_tel"
                onChange={this.updateInput}
                placeholder="Телефон"
              />
            </div>
          </td>
          <td>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.sakh_captain}
                name="sakh_captain"
                onChange={this.updateInput}
                placeholder="Капитан"
              />
            </div>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.sakh_captain_bd}
                name="sakh_captain_bd"
                onChange={this.updateInput}
                placeholder="Д.р. капитана"
              />
            </div>
          </td>
          <td>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.sakh_fisher1}
                name="sakh_fisher1"
                onChange={this.updateInput}
                placeholder="Ловец 2"
              />
            </div>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.sakh_fisher1_bd}
                name="sakh_fisher1_bd"
                onChange={this.updateInput}
                placeholder="Д.р. ловца 2"
              />
            </div>
          </td>
          <td>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.sakh_fisher2}
                name="sakh_fisher2"
                onChange={this.updateInput}
                placeholder="Ловец 3"
              />
            </div>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.sakh_fisher2_bd}
                name="sakh_fisher2_bd"
                onChange={this.updateInput}
                placeholder="Д.р. ловца 3"
              />
            </div>
          </td>
          <td>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.sakh_fisher3}
                name="sakh_fisher3"
                onChange={this.updateInput}
                placeholder="Ловец 4"
              />
            </div>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.sakh_fisher3_bd}
                name="sakh_fisher3_bd"
                onChange={this.updateInput}
                placeholder="Д.р. ловца 4"
              />
            </div>
          </td>
        </tr>
      );
    }
    else{
      return (
        <tr onClick={this.startEditing}>
          <td>{data.sakh_team + (data.sakh_special ? " (соц)" : "")}<br />{data.sakh_date}</td>
          <td>{data.sakh_email}<br />{data.sakh_tel}</td>
          <td>{data.sakh_captain}<br />{data.sakh_captain_bd}</td>
          <td>{data.sakh_fisher1}<br />{data.sakh_fisher1_bd}</td>
          <td>{data.sakh_fisher2}<br />{data.sakh_fisher2_bd}</td>
          <td>{data.sakh_fisher3}<br />{data.sakh_fisher3_bd}</td>
        </tr>
      );
    }

  }
}

export default connect(null, { editSets })(SetsSakhItem);



// WEBPACK FOOTER //
// ./src/components/settings/SetsSakhItem.js